import { restClient } from '@/Core/Services/RestClientService'
import { GetRestUrlByResourceTask } from '@/Core/Tasks/Resources/GetRestUrlByResourceTask'

/**
 * PATCH /services/users/{userId} with personal-info fields.
 * `values` is the form payload — `lastName`, `firstName`, `middleName`, `email`, and optional `photo` IRI (`fullName` is read-only: the backend composes it).
 *
 * The Resource lookup goes through `GetRestUrlByResourceTask('Setting.User', 'patch', ...)`
 * to match the URL convention used elsewhere in the codebase.
 */
export const SavePersonalInfoTask = async (userId: string, values: Record<string, any>): Promise<any> => {
    const url = GetRestUrlByResourceTask('Setting.User', 'patch', { id: userId })
    if (!url) throw new Error('Setting.User resource URL not resolved')
    const req = restClient.patch(url, { json: values })
    if (!req) throw new Error('restClient.patch returned null')
    return req
}
